import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getSettingMultimodalProductSearch } from "@faire/retailer-visitor-shared/settings/useSettingMultimodalProductSearch";
/** Encodes a text and images url into a single string to represent a multimodal query */ export var encodeMultimodalQuery = function(text, imageUrls) {
    if (!getSettingMultimodalProductSearch()) {
        return text;
    }
    return "||text||".concat(text, "||image||").concat(imageUrls.join(","));
};
/**
 * Decodes a multimodal query string into a text and images url.
 * Returns undefined if the query is not a multimodal query or if the feature is disabled.
 */ export var decodeMultimodalQuery = function(query) {
    if (!getSettingMultimodalProductSearch()) {
        return undefined;
    }
    if (query === undefined) {
        return undefined;
    }
    var pattern = /^\|\|text\|\|(.*)\|\|image\|\|(.*)$/;
    var match = query.match(pattern);
    if (match) {
        var _match = _sliced_to_array(match, 3), text = _match[1], imageUrls = _match[2];
        return {
            text: text !== null && text !== void 0 ? text : "",
            imageUrls: (imageUrls !== null && imageUrls !== void 0 ? imageUrls : "").split(",").filter(Boolean)
        };
    } else {
        return undefined;
    }
};
/**
 * Decodes a multimodal query string into a text, returning only the text part.
 * Returns the query if it is not a multimodal query or if the feature is disabled.
 */ export function decodeMultimodalQueryText(query) {
    var _decodeMultimodalQuery;
    var _decodeMultimodalQuery_text;
    return (_decodeMultimodalQuery_text = (_decodeMultimodalQuery = decodeMultimodalQuery(query)) === null || _decodeMultimodalQuery === void 0 ? void 0 : _decodeMultimodalQuery.text) !== null && _decodeMultimodalQuery_text !== void 0 ? _decodeMultimodalQuery_text : query;
}
